import React from 'react';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PUBLICATION_STATUS } from 'constants/constants';
import messages from './messages';
import { getPublicationOutputSummary } from 'utils/getPublicationOutputSummary';
import PublicationMarketsTooltip from 'components/PublicationStatusMarkets/PublicationMarketsTooltip';

import {
  PublishStatusStyle,
  PublishStatusCircle,
  HollowCircle,
} from './styles';

const PublishStatusIcon = ({
  activity,
  theme,
}) => {
  const publicationDetails = activity?.publicationDetails;
  const publicationOutputRows = Array.isArray(publicationDetails) ? publicationDetails : [];  

  const { marketsExist, markets, currentStatus } = getPublicationOutputSummary(
    publicationOutputRows,
    'oculusStatus',
  );

  if (publicationOutputRows.length === 0) {
    return <></>;
  }

  if (!currentStatus) {
    return (
      <HollowCircle>
        <PublishStatusStyle>Status Unknown</PublishStatusStyle>
      </HollowCircle>
    );
  }

  const renderStatus = (color, label) => (
    <PublishStatusCircle color={color} marketsExist={marketsExist} marginTop={2}>
      <PublishStatusStyle>
        {label}
        <PublicationMarketsTooltip
          markets={markets}
          marketsExist={marketsExist}
          theme={theme}
          messages={messages}
        />
      </PublishStatusStyle>
    </PublishStatusCircle>
  );
  switch (currentStatus) {
    case PUBLICATION_STATUS.IN_REVIEW:
      return renderStatus(
        theme['color.magenta'],
        intl.formatMessage(
          marketsExist ? messages.marketsInReview : messages.inReview,
        ),
      );
    case PUBLICATION_STATUS.PUBLISHED_LIVE:
      return renderStatus(
        theme['color.green'],
        intl.formatMessage(
          marketsExist ? messages.marketsLive : messages.publishedLive,
        ),
      );
    default:
      return null;
  }
};

export default PublishStatusIcon;
